import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import { makeStyles } from '@mui/styles'
import React, { useState } from 'react'

import Box from '@eversports/klimt-primitives/legacy/Box'
import { PurchaseOption } from '../../typings/Product'

import { useIntl } from '../../localization/react'
import ProductInformationDialog from './ProductInformationDialog'

interface Props {
  product: PurchaseOption
}

const useStyles = makeStyles({
  icon: {
    cursor: 'pointer',
    alignSelf: 'flex-start',
  },
})

const ProductInformation: React.FC<React.PropsWithChildren<Props>> = ({ product }) => {
  const classes = useStyles()
  const intl = useIntl()
  const [showProductInformation, setShowProductInformation] = useState(false)

  const handleClick = () => {
    setShowProductInformation(!showProductInformation)
  }

  const handleClose = () => {
    setShowProductInformation(false)
  }

  return (
    <>
      <Box
        component="button"
        sx={{ background: 'transparent', border: 'none', padding: 0 }}
        onClick={handleClick}
        aria-label={intl.productInfoAriaLabel()}
      >
        <Icon icon={Icons.INFO} size="large" color="primary.main" className={classes.icon} />
      </Box>
      <ProductInformationDialog product={product} isOpen={showProductInformation} onClose={handleClose} />
    </>
  )
}

export default ProductInformation
